function ordinal(n: number): string {
  if (n === 1 || n === 21 || n === 31) return `${n}st`
  if (n === 2 || n === 22) return `${n}nd`
  if (n === 3 || n === 23) return `${n}rd`
  return `${n}th`
}

/** Compact month + year, e.g. "mar 2024" */
export function formatShortDate(isoDate: string) {
  return new Date(isoDate).toLocaleDateString('sv-SE', { month: 'short', year: 'numeric' })
}

export function formatMeetingDate(isoDate: string) {
  const d = new Date(isoDate)
  const month = d.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' })
  const day = d.getUTCDate()
  const year = d.getUTCFullYear()
  const dayOfWeek = d.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' })
  return { display: `${month} ${ordinal(day)}, ${year}`, dayOfWeek }
}
